import { useTranslation } from 'react-i18next';
import {
    Navigate,
    createSearchParams,
    useNavigate,
    useParams,
    useSearchParams,
} from 'react-router-dom';

import { DrugFamilyHeader } from '../../components/common/DrugFamilyHeader';
import { OfferSelection } from '../../components/provider-offers';
import { getFragment } from '../../graphql';
import { GetProviderOffersDocument } from '../../graphql/generated/graphql';
import { QueryLoader } from '../../loaders';
import { getAbsoluteRoute } from '../../util';

export const DrugOfferSelectionRoute = () => {
    const [searchParams] = useSearchParams();
    const { providerOffersId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const Loader = QueryLoader<typeof GetProviderOffersDocument>;

    const quantityInput = searchParams.get('qInput');
    const quantity = searchParams.get('quantity');

    if (!providerOffersId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    return (
        <Loader
            query={GetProviderOffersDocument}
            variables={{
                id: providerOffersId,
            }}
            render={(data) => {
                const providerOffers = getFragment(data.providerOffers);

                const product =
                    providerOffers?.product.__typename === 'Product' &&
                    getFragment(providerOffers?.product);

                if (providerOffers && product) {
                    const chosenQuantity =
                        quantityInput ??
                        quantity ??
                        String(product.modeQuantity);

                    const newSearchParams = createSearchParams({
                        qInput: chosenQuantity,
                    }).toString();

                    const onSelect = (selectedOfferId: string) =>
                        navigate({
                            pathname: getAbsoluteRoute('transfer.root', {
                                offerId: selectedOfferId,
                                providerOffersId: providerOffersId,
                            }),
                            search: newSearchParams,
                        });

                    const buttonText = t(
                        'offerSelection.button.reviewOverview'
                    );

                    return providerOffers.offers.length > 1 ? (
                        <OfferSelection
                            providerOffers={providerOffers}
                            header={<DrugFamilyHeader drugId={product.id} />}
                            onSelect={onSelect}
                            buttonText={buttonText}
                        />
                    ) : (
                        <Navigate
                            to={{
                                pathname: getAbsoluteRoute('transfer.root', {
                                    providerOffersId,
                                    offerId: getFragment(
                                        providerOffers.offers[0]
                                    ).id,
                                }),
                                search: newSearchParams,
                            }}
                        />
                    );
                }

                return <Navigate to={getAbsoluteRoute('error')} />;
            }}
        />
    );
};
